import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputText from 'modules/_shared/components/InputText';
import InputRadio from 'modules/_shared/components/InputRadio';
import { MessageType } from 'modules/_shared/components/InputMessage';

import { useCommunicationsPage } from '../context/CommunicationsPageContext';

const SenderView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useCommunicationsPage();

  return (
    <div>
      <div className="steps clearfix mb-3">
        <ul role="tablist">
          <li role="tab" className="first last current">
            <h5>{t('Sender')}</h5>
          </li>
        </ul>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <InputText
            id="sender-email"
            label={t('Email')}
            rightText={data.senderDomain}
            value={data.senderEmailLocalPart}
            onChange={actions.handleChangeSenderEmailLocalPart}
            maxLength={50}
            showCounter
          />
        </div>

        <div className="col-md-6">
          <InputText
            id="sender-name"
            label={t('Name')}
            value={data.senderName}
            onChange={actions.handleChangeSenderName}
            maxLength={50}
            showCounter
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label d-block">
              {t('DoYouWantToModifyTheResponseEmail')}
            </label>

            <div className="d-flex mt-1">
              <InputRadio
                id="reply-yes"
                checked={data.hasReplyTo}
                label={t('Yes')}
                onChange={actions.handleToggleHasReplyTo}
              />

              <div className="ml-4">
                <InputRadio
                  id="reply-no"
                  checked={!data.hasReplyTo}
                  label="No"
                  onChange={actions.handleToggleHasReplyTo}
                />
              </div>
            </div>
          </div>
        </div>

        {data.hasReplyTo && (
          <div className="col-md-6 mt-3 mt-md-0">
            <InputText
              id="replay-email"
              label={t('ReplyEmail')}
              value={data.replyToEmail}
              onChange={actions.handleChangeReplyToEmail}
              additionalInfo={
                !data.isValidReplyToEmail ? t('InvalidEmail') : ''
              }
              additionalInfoType={
                !data.isValidReplyToEmail ? MessageType.ERROR : undefined
              }
              maxLength={50}
              emailInput
              showCounter
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SenderView;
